<template>
  <div class="login-page">
    <div class="login">
      <div class="login-logo"></div>
      <div class="login-main">
        <div class="login-box">
          <h1>登录</h1>
          <div class="login-info">
            <van-field
              v-model.number="mobile"
              type="number"
              maxlength="11"
              placeholder="请输入手机号"
            >
            </van-field>
            <van-field
              v-model.trim="password"
              type="password"
              placeholder="请输入密码"
            >
            </van-field>
            <p class="footer-links">
              <router-link style="margin-right:10px" to="/register"
              >注册</router-link>
              <router-link to="/resetPassword"
              >找回密码</router-link>
            </p>
          
            <van-button
              class="login-btn"
              :disabled="!(mobile && password)"
              round
              color="#e95944"
              type="info"
              block
              @click="toLogin"
              >登录</van-button
            >

          </div>
        </div>
        <div class="login-box login-news">
          <h1>公告栏</h1>
          <ul>
            <li v-for="item in noticeList" :key="item.id || item.title">
              <h5>
                <a
                  href="javascript:;"
                  class="notice-title"
                  @click="goNoticeDetail(item)"
                >{{ item.title || "#" }}</a>
                <span>{{ formatNoticeDate(item.create_time || item.created_at) }}</span>
              </h5>
              <p class="notice-content">{{ formatNoticeSummary(item.content) || "-" }}</p>
            </li>
            <li v-if="noticeList.length === 0">
              <p>暂无公告</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="login-footer"></div>
    </div>
    <van-popup
      v-model="cardidPopupVisible"
      class="cardid-popup"
      :close-on-click-overlay="false"
      :closeable="false"
      round
    >
      <div class="cardid-popup-content">
        <h3>补充身份证号码</h3>
        <p>请先补充身份证号码后再完成登录</p>
        <van-field
          v-model.trim="cardid"
          maxlength="18"
          placeholder="请输入身份证号码"
        />
        <van-button
          class="cardid-submit-btn"
          type="info"
          color="#e95944"
          block
          round
          @click="submitCardid"
        >提交并登录</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import cookies from "@/libs/util.cookies";
import md5 from 'js-md5'

export default {
  name: "Login",
  data() {
    return {
      mobile: "",
      password: "",
      noticeList: [],
      cardidPopupVisible: false,
      cardid: "",
      pendingLoginUser: null,
    };
  },
  mounted() {
    this.getNoticeList();
  },
  methods: {
    checkFn() {
      const reg = /^1\d{10}$/;
      if (!reg.test(this.mobile)) {
        this.$toast("请输入正确的手机号码！");
        return false;
      }
      if (this.password.length < 6) {
        this.$toast("密码不能少于6位");
        return false;
      }
      return true;
    },
    toLogin() {
      const n = this.checkFn();
      if (!n) {
        return;
      }
      this.$toast.loading({
        type: "loading",
        message: "登录中...",
        loadingType: "spinner",
        duration: 0,
      });
      const data = {
        mobile: this.mobile,
        password: md5(this.password),
      };
      this.$api.SYS_USER_LOGIN(data).then((res) => {
        this.$toast.clear();
        if (!res || !res.token) return;
        if (!res.cardid) {
          // 需要先补充身份证信息，先暂存登录态用于补充接口鉴权
          this.pendingLoginUser = res;
          cookies.set(process.env.VUE_APP_TOKEN, res.token);
          this.cardid = "";
          this.cardidPopupVisible = true;
          return;
        }
        this.finishLogin(res.token, res.username);
      });
    },
    checkCardid() {
      const value = (this.cardid || "").toUpperCase();
      const reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
      if (!reg.test(value)) {
        this.$toast("请输入正确的身份证号码");
        return false;
      }
      return true;
    },
    submitCardid() {
      if (!this.checkCardid()) return;
      this.$toast.loading({
        type: "loading",
        message: "提交中...",
        loadingType: "spinner",
        duration: 0,
      });
      this.$api
        .COMPLETE_CARDID_INFO({
          cardid: this.cardid.toUpperCase(),
        })
        .then((res) => {
          this.$toast.clear();
          const token = (res && res.token) || (this.pendingLoginUser && this.pendingLoginUser.token);
          const username = (res && res.username) || (this.pendingLoginUser && this.pendingLoginUser.username);
          if (!token) return;
          this.cardidPopupVisible = false;
          this.finishLogin(token, username);
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    finishLogin(token, username) {
      if (username) {
        cookies.set("username", username);
      }
      cookies.set(process.env.VUE_APP_TOKEN, token);
      this.$router.replace("/index");
    },
    // 获取公告列表（与首页接口保持一致，仅取前2条）
    getNoticeList() {
      this.$api
        .GET_NOTICE_HOME_LIST({
          limit: 2,
          offset: 0,
        })
        .then((res) => {
          this.noticeList = res || [];
        });
    },
    formatNoticeContent(content = "") {
      if (!content) return "";
      return String(content)
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, " ")
        .trim();
    },
    formatNoticeSummary(content = "") {
      const text = this.formatNoticeContent(content);
      if (!text) return "";
      const maxLen = 92;
      return text.length > maxLen ? `${text.slice(0, maxLen)}...` : text;
    },
    formatNoticeDate(dateStr = "") {
      if (!dateStr) return "";
      return String(dateStr).slice(0, 10);
    },
    goNoticeDetail(item) {
      if (!item || !item.id) return;
      this.$router.push({
        name: "NoticeDetail",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-links{
  text-align:right;
  a{
    color:#e95944;
  }
}


.login-news {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    border-top: 1PX solid #f1f4f6 !important;
    padding: 12PX 0 !important;
    overflow: hidden;
  }
  h5 {
    margin: 0 0 8PX !important;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8PX !important;
  }
  h5 span {
    flex-shrink: 0;
    color: #999;
    font-size: 13px;
    line-height: 24px;
    white-space: nowrap;
  }
  .notice-title {
    flex: 1;
    min-width: 0;
    color: #1b33b1;
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .notice-content {
    margin: 0;
    color: #666;
    font-size: 14px;
    line-height: 22px;
    min-height: 44px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
}
.login-page {
  background:url(../../assets/images/common/login-m1.png);
  background-size:100% 100%;
  min-height:100vh;
  .login {
    height: 100vh;
    padding-top:10px;
    position: relative;
    .login-main {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      display: block;
    }
   
    .login-logo{
      width:320px;
      height:125px;
      margin:0 auto;
      margin-top:20px;
      background:url(../../assets/images/common/login-m2.png);
      background-size:100% auto;
      background-repeat:no-repeat;
    }
    ::v-deep {
      .van-cell {
        background-color: transparent;
        margin-top: 30px;
        padding: 0;
        display: flex;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid #f1f4f6;
      }
      .van-field__control {
        font-size: 16px;
        color: #333;
      }
      .van-field__right-icon {
        display: flex;
      }
      .van-cell::after {
        display: none;
      }
    }
    .title-word {
      .top {
        font-size: 28px;
      }
      .welcome {
        font-size: 14px;
        color: #666666;
        margin-top: 10px;
      }
    }
    &-info {
      // padding: 0 33px;
      // margin-top: -50px;
      .btn-w {
        min-width: 86px;
        cursor: pointer;
      }
      .time {
        // border-color: #999 !important;
        // background: #999 !important;
        background: #e95944 !important;
        // border-radius: 17px;
        opacity: 0.5;
      }

      .phone {
        width: 13px;
        height: 17px;
        margin-right: 15px;
        margin-top: 10px;
      }
      .pwd {
        width: 17px;
        height: 16px;
        margin-right: 12px;
        margin-top: 5px;
      }
      .right-icon {
        width: 34px;
        height: 34px;
      }
      .login-btn {
        height: 50px;
        margin-top: 40px;
      }
      .register {
        font-size: 14px;
        color: #666666;
        text-align: right;
        margin-top: 15px;
      }
      .pact {
        display: flex;
        margin-top: 18px;
        .van-checkbox {
          // align-self: flex-start;
          margin-right: 10px;
          min-width: 20px;
        }
        .pact-text {
          font-size: 12px;
          a {
            color: #e95944;
          }
        }
      }
    }

  }
   .login-box{      
      max-width: none;
      background:#fff;
      margin:0 auto 12px;
      border-radius:20px;
      padding:16px 20px;
      box-shadow:5px 5px 20px #efefef;
      position: relative;
      z-index:999;
      h1{
        font-size:28px;
      }
    }
    .login-footer{
      width:100%;
      height:165px;
      margin:0 auto;
      margin-top:40px;
      background:url(../../assets/images/common/login-m3.png);
      background-size:100% auto;
      background-repeat:no-repeat;
      position: fixed;
      bottom:0;
      left:50%;
      margin-left:-50%;

    }
}
@media (min-width: 992px) {
  .cardid-popup {
    width:100VW;
    height:100VH;
    background: rgba(0, 0, 0, 0.5);
  }
  .cardid-popup-content {
    width: 460PX !important;
    padding: 20PX 16PX 16PX !important;
    background: rgba(255, 255, 255, 1);
    border-radius: 16PX;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -230PX;
    margin-top: -100PX;
    h3 {
      margin: 0 0 8px;
      font-size: 18px;
      color: #333;
      text-align: center;
    }
    p {
      margin: 0 0 10px;
      color: #999;
      font-size: 13px;
      text-align: center;
    }
    .cardid-submit-btn {
      margin-top: 16px;
    }
  }
  .login-page {
    background:url(../../assets/images/common/login-pc1.png);
    background-size:100% 100%;
    min-height:100vh;
    overflow: hidden;
    .login {
      height: 100%;
      padding-top: 0;
      position: relative;
      .login-main {
        width: 92%;
        max-width: 1200px;
        margin: 8px auto 0;
        display: flex;
        align-items: stretch;
        gap: 24px;
      }
      .login-logo{
        width:540px;
        height:180px;
        margin:0 auto;
        margin-top:16px;
        background:url(../../assets/images/common/login-pc2.png);
        background-size:100% auto;
        background-repeat:no-repeat;
      }
      
      ::v-deep {
        .van-cell {
          background-color: transparent;
          margin-top: 30px;
          padding: 0;
          display: flex;
          align-items: center;
          height: 50px;
          border-bottom: 1px solid #f1f4f6;
        }
        .van-field__control {
          font-size: 16px;
          color: #333;
        }
        .van-field__right-icon {
          display: flex;
        }
        .van-cell::after {
          display: none;
        }
      }
      .title-word {
        .top {
          font-size: 28px;
        }
        .welcome {
          font-size: 14px;
          color: #666666;
          margin-top: 10px;
        }
      }
      &-info {
        // padding: 0 33px;
        // margin-top: -50px;
        .btn-w {
          min-width: 86px;
          cursor: pointer;
        }
        .time {
          // border-color: #999 !important;
          // background: #999 !important;
          background: #e95944 !important;
          // border-radius: 17px;
          opacity: 0.5;
        }

        .phone {
          width: 13px;
          height: 17px;
          margin-right: 15px;
          margin-top: 10px;
        }
        .pwd {
          width: 17px;
          height: 16px;
          margin-right: 12px;
          margin-top: 5px;
        }
        .right-icon {
          width: 34px;
          height: 34px;
        }
        .login-btn {
          height: 50px;
          margin-top: 40px;
        }
        .register {
          font-size: 14px;
          color: #666666;
          text-align: right;
          margin-top: 15px;
        }
        .pact {
          display: flex;
          margin-top: 18px;
          .van-checkbox {
            margin-right: 10px;
            min-width: 20px;
          }
          .pact-text {
            font-size: 12px;
            a {
              color: #e95944;
            }
          }
        }
      }
      .login-info{
        width:100%;
        margin:20px auto;
      }
    }
    .login-box{
      flex: 1 1 0;
      min-width: 0;
      max-width:none;
      background:#fff;
      margin:0;
      border-radius:20px;
      padding:20px 28px;
      box-shadow:5px 5px 20px #efefef;
      position: relative;
      z-index:999;
      h1{
        font-size:24px;
      }
    }
    .login-box:first-child {
      min-width: 460px;
    }
    .login-news {
      .notice-title {
        font-size: 20px;
        line-height: 30px;
      }
      h5 span {
        font-size: 14px;
        line-height: 24px;
      }
      .notice-content {
        font-size: 15px;
        line-height: 24px;
      }
    }
    .login-footer{
      width:600px;
      height:215px;
      margin:0 auto;
      margin-top:40px;
      background:url(../../assets/images/common/login-pc3.png);
      background-size:100% auto;
      background-repeat:no-repeat;
      position: fixed;
      bottom:0;
      left:50%;
      margin-left:-300px;

    }
  }
}

@media (max-width: 991px) {
  .cardid-popup {
    width: 300PX !important;
  }
  .cardid-popup-content {
    padding: 20px 16px 16px !important;
    h3 {
      margin: 0 0 8px;
      font-size: 18px;
      color: #333;
      text-align: center;
    }
    p {
      margin: 0 0 10px;
      color: #999;
      font-size: 13px;
      text-align: center;
    }
    .cardid-submit-btn {
      margin-top: 16px;
    }
  }
  .login-page {
    .login {
      height: auto;
      min-height: 100vh;
      padding-bottom: 120px;
      .login-main {
        display: block;
      }
    }
    .login-box {
      margin: 0 auto 12px;
      padding: 14px 16px;
      border-radius: 14px;
      h1 {
        font-size: 22px;
      }
    }
    .login-news {
      .notice-title {
        font-size: 15px;
        line-height: 24px;
      }
      h5 span {
        font-size: 12px;
        line-height: 20px;
      }
      .notice-content {
        font-size: 13px;
        line-height: 20px;
      }
    }
    .login-footer {
      position: fixed;
      height: 120px;
    }
  }
}
</style>
